import $ from 'jquery';

$(window).on('load', () => {
	const swiperPosts = document.querySelectorAll('.el-loop-carousel .swiper');

	swiperPosts.forEach( slider => {
		slider.swiper.destroy(true, true);

		new Swiper(slider, {
			slidesPerView: 'auto',
		});
	});
});
